export default "__VITE_PUBLIC_ASSET__5ca7600d__"